/* eslint-disable react-hooks/exhaustive-deps */
import React, { lazy, useEffect } from 'react'
import { FrontUrls } from 'Constants/FrontUrls'
import { Switch, useHistory } from 'react-router-dom'
import { useAppDispatch } from 'Src/hooks'
import { useEffectOnce } from 'Src/hooks/useEffectOnce'
import { ordersListSelectors, ordersListSlice } from 'Pages/registratorCabinet'
import { useSelector } from 'react-redux'
import { deviceDetect, filtersSlice, LazyRoute, PAGE_SLUG } from 'Modules'

const RegistratorCabinetOrderListLazy = lazy(
	() => import('Pages/registratorCabinet/components/mobile/OrderList/List/index')
)
const RegistratorCabinetOrderInfoLazy = lazy(
	() => import('Pages/registratorCabinet/components/mobile/OrderList/Info/index')
)
const RegistratorCabinetOrderReportLazy = lazy(
	() => import('Pages/registratorCabinet/components/mobile/OrderList/UnloadReport/index')
)

const RegistratorCabinetOrderFiltersLazy = lazy(
	() => import('Pages/registratorCabinet/components/mobile/OrderList/Filters/index')
)

const RegistratorCabinetOrderEditLazy = lazy(
	() => import('Pages/registratorCabinet/components/mobile/OrderEdit/index')
)

const RegistratorCabinetOrderCreateLazy = lazy(
	() => import('Pages/registratorCabinet/components/mobile/OrderCreate/index')
)

const actions = {
	clearFilters: filtersSlice.actions.clearFilters,
	getRbidosRequestList: ordersListSlice.actions.getAll,
	clearAll: ordersListSlice.actions.clearAll,
}

export const MobileRegistratorCabinetRoutes = () => {
	const history = useHistory()
	const id = window.location?.pathname.split('/').pop()
	const isMobile = useSelector(deviceDetect.getIsMobile)
	const params = useSelector(ordersListSelectors.getRequestParams)

	const { clearFilters, getRbidosRequestList, clearAll } = useAppDispatch(actions)

	useEffectOnce(() => {
		getRbidosRequestList({ params })
		return () => {
			clearAll()
			clearFilters(PAGE_SLUG.REGISTRATION_OFFICE_REDESIGN)
		}
	})

	const editPage =
		window.location.pathname === FrontUrls.cabinet_redesign.order_edit.replace(':id', id)

	useEffect(() => {
		if (editPage && isMobile) {
			history.push(FrontUrls.cabinet_redesign_mobile.info.replace(':id', id))
		}
	}, [editPage, isMobile])

	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.cabinet_redesign_mobile.draft_page}
				lazyComponent={RegistratorCabinetOrderEditLazy}
				key={FrontUrls.cabinet_redesign_mobile.draft_page}
			/>
			<LazyRoute
				exact
				path={FrontUrls.cabinet_redesign_mobile.create}
				lazyComponent={RegistratorCabinetOrderCreateLazy}
				key={FrontUrls.cabinet_redesign_mobile.create}
			/>
			<LazyRoute
				exact
				path={FrontUrls.cabinet_redesign_mobile.info}
				lazyComponent={RegistratorCabinetOrderInfoLazy}
				key={FrontUrls.cabinet_redesign_mobile.info}
			/>
			<LazyRoute
				exact
				path={FrontUrls.cabinet_redesign_mobile.report}
				lazyComponent={RegistratorCabinetOrderReportLazy}
				key={FrontUrls.cabinet_redesign_mobile.report}
			/>
			<LazyRoute
				exact
				path={FrontUrls.cabinet_redesign_mobile.filters}
				lazyComponent={RegistratorCabinetOrderFiltersLazy}
				key={FrontUrls.cabinet_redesign_mobile.filters}
			/>
			<LazyRoute
				exact
				path={FrontUrls.cabinet_redesign.cabinet}
				lazyComponent={RegistratorCabinetOrderListLazy}
				key={FrontUrls.cabinet_redesign.cabinet}
			/>
		</Switch>
	)
}
